import { get, isArray, merge, values } from 'lodash';

/*
 * sanatizeModel() performs below function
 * - to find only object chooser field from the given form data
 * - replace the value of this object chooser field to tip||tip[]
 * - call updatedSubmitModel() to patch object chooser values to given form data
 * - return the updated form data
 * - if no object chooser present return the unmodified form data back
 * @params
 * submitedModel is the form data
 * objectChooserField is the array of field tips
 */
export function sanatizeModel(submitedModel, objectChooserField): any {
  const elementsArray = [];
  if (objectChooserField?.length > 0) {
    const fieldKeys = Object.keys(submitedModel);
    objectChooserField.forEach((objectId) => {
      if (fieldKeys.indexOf(objectId) > -1) {
        const value = submitedModel[objectId];
        if (isArray(value)) {
          const modifiedElements = value.map((val) => {
            return get(val, 'value', []);
          });
          elementsArray.push([objectId, modifiedElements]);
        } else {
          const objValue = values(value);
          elementsArray.push([objectId, objValue[1]]);
        }
      }
    });
    const model = updatedSubmitModel(submitedModel, elementsArray);
    return model;
  } else {
    return submitedModel;
  }
}

/*
 * updatedSubmitModel() is to performs
 * - patch the object chooser values to the given form data
 * @params
 * submitedModel is the form data
 * elementsArray is the field values of object chooser.
 */
export function updatedSubmitModel(submitedModel, elementsArray): any {
  const arrayVal = elementsArray.reduce(
    (obj, item) => ((obj[item[0]] = item[1]), obj),
    {}
  );
  const newObj = merge(submitedModel, arrayVal);
  return newObj;
}
